import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode'; // npm install jwt-decode
import { setToken, startTokenTimer } from "../../services/authService";
 
const AuthSuccess = () => {
  const navigate = useNavigate();
  const { search } = useLocation();
 
  useEffect(() => {
    const params = new URLSearchParams(search);
    const token = params.get('token');
 
    if (token) {
      // ⬅️ NEW: helper se token set karo
      setToken(token);
      startTokenTimer(token);   // auto logout after 60s
 
      // Decode token to get user info and store it
      try {
        const decoded = jwtDecode(token); // contains id, name, email
        localStorage.setItem('user', JSON.stringify(decoded));
        console.log("✅ User stored in localStorage:", decoded);
      } catch (err) {
        console.error("❌ Failed to decode token", err);
      }
 
      window.location.href = "/dashboard"; // ⬅️ navigate ki jagah hard redirect
    } else {
      navigate("/login");
    }
  }, [search, navigate]);
 
  return <p>Logging in with Outlook...</p>;
};
 
export default AuthSuccess;
 